import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { LastSeenReportService } from '../../../services/last-seen-report.service';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-last-seen-report',
  templateUrl: './last-seen-report.component.html',
  styleUrls: ['./last-seen-report.component.css']
})
export class LastSeenReportComponent implements OnInit {

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    months: 1,
    quick_Search: ""
  };

  client;

  selectedOptions: string[] = [
    'Serial #',
    'Tag',
    'Cylinder Size',
    'Product Type',
    'Cylinder Material',
    'Company Name',
    'Location Name',
    'Last Activity At',
    'Last Updated'
  ];

  availableOptions: string[] = [
    'Serial #',
    'Tag',
    'Cylinder Size',
    'Product Type',
    'Cylinder Material',
    'Company Name',
    'Location Name',
    'Last Activity At',
    'Last Updated'
  ];

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;
  is_client = false;

  showPopup: boolean = false;
  popupContent: string = '';

  constructor(authService: AuthService, public lastSeenReportService: LastSeenReportService, public router: Router,
    private columnService: ColumnService) {

    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
   
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "";

  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    const sortMapping = {
      'lastUpdatedAt': 'Row_Updated_Sorting',
    };

    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = event.newValue;
    this.page.sortBy = sortBy;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.lastSeenReportService.getResults(this.page, this.filter.months, this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.lastSeenReportService.getExcel(this.filter.months).then((data) => {
        importedSaveAs(data, 'Last_Seen.xlsx');
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
   this.columnService.getColumns(this.client.userId, "lastSeenReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "lastSeenReport", this.selectedOptions).then((data) => {
    });
  }
}

